'use client';

import { useMemo } from 'react';
import { ModelTag } from '@/shared/src';
import { useSearch } from '@/app/search-context';
import { filterModels } from './actions/list';
import Dropdown from './dropdown';

export default function SelectModelTagsClient({
  placeholder,
  className,
  tags,
}: {
  placeholder: string,
  className: string,
  tags: ModelTag[]
}) {
  const { allModels, selectedModelTags, toggleModelTag, dataLoading, pageQuery, modelSort, measurementFilters, } = useSearch();

  const availableTagNames = useMemo(() => {
    if (!allModels) return null;
    const filtered = filterModels(allModels, pageQuery, modelSort, selectedModelTags, measurementFilters);
    const names = new Set<string>();
    for (const m of filtered) {
      if (m.tags) for (const t of m.tags) names.add(t.name);
    }
    return names;
  }, [allModels, pageQuery, modelSort, selectedModelTags, measurementFilters,]);

  const tagsToShow = tags.filter(t =>
    !selectedModelTags.includes(t.attributes.name) &&
    (!availableTagNames || availableTagNames.has(t.attributes.name))
  );

  if (tagsToShow.length > 0) {
    return (
      <Dropdown
        className={className}
        options={tagsToShow.map(t => ({ value: t.attributes.name, label: t.attributes.name, }))}
        placeholder={placeholder}
        disabled={dataLoading}
        onChange={toggleModelTag}
        pickMode
      />
    );
  }

  return <></>;
}
